import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchExperienceTripsDtl } from "../services/ExperienceTripsDtl";
import { API_BASE } from "../api/apiConfig";

const Experiencebooking = () => {
  const { id } = useParams();
  const [ExperienceTripsDtldata, setExperienceTripsDtldata] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchExperienceTripsDtl(decodeURIComponent(id));

      if (res?.data) {
         setExperienceTripsDtldata(res.data[0]);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);


  // Modal
  const [open, setOpen] = useState(false);

  
const [openDay, setOpenDay] = useState(1);


  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!ExperienceTripsDtldata) return <p className="text-center py-10">No Data found</p>;

  return (
      <>

     <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 lg:hidden z-50 safe-area-pb">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="text-sm text-slate-400 line-through">
                ₹{ExperienceTripsDtldata.difficulties}
              </span>
              <span className="text-xl font-bold text-slate-900">₹{ExperienceTripsDtldata.charges}</span>
            </div>
            <p className="text-xs text-slate-500">per person · {ExperienceTripsDtldata.spots} spots left</p>
          </div>
          <a target="_blank" href="https://wa.me/918920866123" className="inline-flex items-center justify-center whitespace-nowrap rounded-md ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 py-2 bg-primary text-white hover:bg-primary/90 h-11 px-6 text-sm font-semibold shadow-lg shadow-primary/25">
            Book Now
          </a>
        </div>
      </div>
    </div>
    
    </>
  );
};

export default Experiencebooking;
